import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromFunctionalErrorResponses } from '../models/mapper'
import { FunctionalError } from '../models/types'
import { fetchTransitOperationLogDetailsV2 } from './http'

export async function fetchTransitOperationLogDetails(logId: number): Promise<FunctionalError[]> {
  const responses = await fetchTransitOperationLogDetailsV2(logId)
  return fromFunctionalErrorResponses(responses)
}

export function useFetchTransitOperationLogDetails(logId: number | null, enabled: boolean) {
  return useQuery({
    queryKey: QueryKeys.eventLog.details(logId),
    queryFn: () => fetchTransitOperationLogDetails(logId as number),
    enabled: enabled && !!logId,
    staleTime: Infinity,
  })
}
